import React from "react";

function Header() {
  return <header className="header"> Battlebots Sweepstakes </header>;
}

export default Header;
